
















































import {
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
  computed,
} from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { QuantityBreak } from '@/models/entities/QuantityBreak';

interface Props {
  id: string;
}

interface State {
  entity: QuantityBreak;
  loading: boolean;
}

const Component = defineComponent({
  name: 'QuantityBreakDialog',

  components: {
    EntityDialog,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    let quantityBreak = new QuantityBreak({});

    let isNew = () => !props.id;

    onBeforeMount(async () => {
      if (!isNew()) {
        const res = await $store.dispatch(`quantityBreaksModule/fetchItem`, props.id);
        if (!res) $router.back();
      }
    });

    const state = reactive({
      entity: quantityBreak,
      loading: computed(() => $store.getters['quantityBreaksModule/loading']),
    }) as State;

    watch(
      () => $store.getters['quantityBreaksModule/selectedItem'],
      (newValue: QuantityBreak) => Object.assign(quantityBreak, newValue),
      { immediate: false, deep: true },
    );

    const title = computed(() => {
      if (state.loading) return '';
      if (isNew()) return 'New Quantity Break';
      return `Edit Quantity Break`;
    });

    const rules = {
      from: [
        (v: any) => v !== '' || '"From" is a required field',
        (v: number) => v < 10000 || 'Number couldn`t be longer than 3 digits',
        (v: number) => v > 0 || 'Only positive numbers allowed',
      ],
      to: [
        (v: any) => v !== '' || '"To" is a required field',
        (v: number) => v < 10000 || 'Number couldn`t be longer than 3 digits',
        (v: number) => v > 0 || 'Only positive numbers allowed',
      ],
    };

    return {
      state,
      title,
      rules,
      isNew,
    };
  },
});
export default Component;
